import React from 'react';
import ABSIcon from '../ABSIcon';
import ABSListView from '../ABSList/ABSListView';
import ABSDeletableTableDataHelper from './ABSDeletableTableDataHelper';
import ABSPerfectScrollBar from '../ABSPerfectScrollBar';
import './index.less';

export interface IABSDeletableTableProps {
  columnsData: any[];
  contentData: any[];
  loading?: boolean;
  onDeleteColumn: (column: any) => void;
}
 
export interface IABSDeletableTableState {
  columnsData: any[];
  contentData: any[];
}
 
class ABSDeletableTable extends React.Component<IABSDeletableTableProps, IABSDeletableTableState> {

  onDeleteColumn(column: any) {
    const { onDeleteColumn } = this.props;
    if (onDeleteColumn) {
      onDeleteColumn(column);
    }
  }

  renderClosableTitle = (column: any) => {
    return (
      <div className="title-button">
        <span>{column.title}</span>
        <ABSIcon 
          size={16} 
          type="circle-close-filled"
          onClick={() => this.onDeleteColumn(column)} 
        />
      </div>
    );
  }

  render() {
    const { columnsData, contentData, loading } = this.props;
    const columns = ABSDeletableTableDataHelper.formatColumnsData(columnsData, this.renderClosableTitle);
    return (
      <div className="abs-deletable-table">
        <ABSPerfectScrollBar>
          <ABSListView
            columnsData={columns}
            contentData={contentData}
            loading={loading}
            bordered={true}
            // removeBorder={true}
          />
        </ABSPerfectScrollBar>
      </div>
    );
  }
}
 
export default ABSDeletableTable;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSDeletableTable/index.tsx